﻿import { Directive, ViewContainerRef } from "@angular/core";

@Directive({
  selector: '[applications-host]',
})
export class ApplicationsHostDirective {
  constructor(public viewContainerRef: ViewContainerRef) { }
}
